export const MAX_ORDER_BATCH_SIZE = 1000;

export function parseOrderNoBatch(text) {
  return [...new Set(String(text || '').trim().split(/[\s,，]+/).filter(Boolean))];
}

export function filterOrderNoBatch(rows, numbers) {
  if (!numbers.length) return rows;
  const wanted = new Set(numbers);
  return rows.filter(row => wanted.has(String(row.mainOrderNo == null ? '' : row.mainOrderNo)) ||
    wanted.has(String(row.upstreamOrderNo == null ? '' : row.upstreamOrderNo)));
}

// 批量单号放入请求体，避免 URL 超长；原始粘贴文本只用于表单续填，不重复传给接口。
export function orderSearchRequest(url, params) {
  const query = { ...params };
  delete query.orderNoBatch;
  if (!query.orderNoList) return { method: 'get', url, params: query };
  const body = new URLSearchParams();
  Object.keys(query).forEach(key => {
    if (query[key] != null) body.set(key, Array.isArray(query[key]) ? query[key].join(',') : String(query[key]));
  });
  return { method: 'post', url, data: body.toString(), headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };
}
